import { Radio } from '@dixa/lib-shared-habla';
import { ComponentProps } from 'react';
import { WrappedFieldProps } from 'redux-form';

type Props = WrappedFieldProps & Omit<ComponentProps<typeof Radio>, 'ref'>;

export function FieldRadio({ input, meta, ...radioProps }: Props): JSX.Element {
  return <Radio {...input} {...radioProps} />;
}
